module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Schedule","short_name":"sched","start_url":"/","scope":"https://sched.cwedavies.now.sh/","background_color":"#D45769","theme_color":"#D45769","display":"minimal-ui","icon":"src/images/user.svg"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
